import { LocalStorageService } from 'src/app/services/storage/local-storage.service';
import { UserStorage } from 'src/app/services/storage/local-storage.model';
import { Injectable, inject } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CommonApiService } from "../api/common-api.service";
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private readonly keycloakService = inject(KeycloakService);
  private readonly commonApiService = inject(CommonApiService);
  private readonly localStorageService = inject(LocalStorageService);

  defaultUserData = {
    username: '',
    isAdmin: false,
    menu: null,
    loggedID: 0,
    isCoreMemberOf: ''
  };
  userData: BehaviorSubject<UserStorage> = new BehaviorSubject<UserStorage>(this.defaultUserData);

  refreshUserData() {
    const userFromLocal = JSON.parse(localStorage.getItem('user'));
    this.commonApiService.getMembersRolesOnLogin(this.keycloakService.getKeycloakInstance().token).subscribe({
      next: (res) => {
        const coreMemberOf = res.sircles.find((sircle) => sircle.coreMember);
        const userDataDTO = {
          username: userFromLocal?.username ?? '',
          isAdmin: res['admin'],
          menu: res['sircles'],
          loggedID: res['id'],
          isCoreMemberOf: coreMemberOf?.id ? coreMemberOf.id : ''
        };
        this.userData.next(userDataDTO);
        this.localStorageService.setUser(userDataDTO);
      },
      error: (error) => {
        // Transient auth/network failure (e.g. expired token on a periodic
        // refresh tick): keep the last known user data, don't crash the app.
        console.error('Failed to refresh user data', error);
      }
    });
    return this.userData;
  }
  
  getUserData(): BehaviorSubject<UserStorage> {
    return this.userData;
  }

  setUserData() {
    this.userData.next(this.localStorageService.getUser());
  }
}
